// Global Sass-like variables for use within CSS
// See https://github.com/postcss/postcss-simple-vars#variables
// Pixel calculations assume 1rem = 16px

const variables = require('../../config/variables');

module.exports = {
  // Colour definitions
  torchRed: '#ff1040',
  crimson: '#e4133f',
  lavendar: '#ffe7eb',
  malibu: '#50b5ff',
  aliceblue: '#f0fAff',
  serenade: '#fff7e9',
  black: '#000',
  white: '#fff',
  darkGrey: '#c0c0c0',
  grey: '#7D8996',
  lightGrey: '#979797',
  lighterGrey: '#ebebeb',
  lightestGrey: '#f9f9f9',
  facebookBlue: '#33589d',
  stravaOrange: '#fc4c02',

  // Color settings
  colorBrand: '$torchRed',
  colorBrandSecondary: '$crimson',
  colorBorder: '$lighterGrey',
  colorBorderDark: '$darkGrey',
  colorBorderTransparent: 'color($white a(20%))',

  // Breakpoints
  breakpointSM: '0px',
  breakpointMD: '768px',
  breakpointLG: '1160px',

  // Container
  containerMaxWidthSM: '320px',
  containerMaxWidthMD: '648px',
  containerMaxWidthLG: '1080px',

  // Grid
  gridColumnsSM: 6,
  gridColumnsMD: 12,
  gridColumnsLG: '$gridColumnsMD',

  gridGutterWidthSM: '1.125rem', // 18px
  gridGutterWidthMD: '$gridGutterWidthSM',
  gridGutterWidthLG: '1.875rem', // 30px

  gridOffsetWidthSM: '0px',
  gridOffsetWidthMD: '$gridGutterWidthMD',
  gridOffsetWidthLG: '$gridGutterWidthLG',

  gridBaseline: '1.875rem', // 30px
  gridDebug: false,

  // Type
  fontFamily: 'pangram, sans-serif',
  fontSize: '1rem', // Assumes the browser default, typically 16px
  fontWeight: 300, // Weights must match font-face definitions
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  lineHeight: '$gridBaseline',
  bodyTextColor: '$black',
  bodyBgColor: '$lightestGrey',

  // Headings
  headingsMarginTop: 'calc($gridBaseline / 2)',
  headingsMarginBottom: 'calc($gridBaseline / 2)',
  headingsFontFamily: '$fontFamily',
  headingsFontWeight: '$fontWeightBold',
  headingsLineHeight: '$gridBaseline',
  headingsColor: 'inherit',

  // Sizes
  fontSizeH1: '1.625rem', // 26px
  fontSizeH2: '1.375rem', // 22px
  fontSizeH3: '1.125rem', // 18px
  fontSizeH4: '1rem', // 16px
  fontSizeH5: '1rem', // 16px
  fontSizeH6: '1rem', // 16px

  // Links
  linkColor: '$torchRed',
  linkColorDark: '$black',
  linkHoverColor: '$torchRed',

  // Component dimensions
  borderWidth: '0.0625rem',
  borderStyle: '$borderWidth solid $colorBorder',
  borderRadius: '0.1875rem', // 3px
  boxShadowStyle: '0 0.0625rem 0.125rem rgba(0, 0, 0, 0.03)', // 0 1px 2px

  // Header
  headerHeight: '4.375rem', // 70px, used to determine page height

  // Z-indexes
  zIndexImageGradient: 950,
  zIndexSticky: 970,
  zIndexDropdown: 1000,
  zIndexFixed: 1030,
  zindexModal: 1050,
  zIndexOverlay: 1100,

  // Media root
  mediaRoot: variables.default.MEDIA_ROOT,
};



// WEBPACK FOOTER //
// ./app/src/base-styles/vars.js